// extracted by mini-css-extract-plugin
module.exports = {"_icon-glow-style":"IconGlowStyle__icon-glow-style_iKuMH"};